/**
 * Creado por Norte70
 * @author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 26/01/2021
 */

import * as SessionUtils from './../../../core/session_utils.js'

const cancelOrderRequest = () => {
    return {
        session_token: SessionUtils.getGuestUserToken(),
        invited: SessionUtils.isGuestUser(),
        accion: 0,
        id: 0,
        token: null
    }
}

export default cancelOrderRequest;